/**
 * The teams this client is on (GET /api/user/teams) — shown on More and on the
 * Calendar's program banner. followsTeamProgram = false means the coach gave
 * them their own program while they stay on the team.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface MyTeam {
  id: string;
  name: string;
  description: string | null;
  programName: string | null;
  followsTeamProgram: boolean;
  coachName: string | null;
  memberCount: number;
}

export function useMyTeams(): MyTeam[] {
  const q = useQuery({
    queryKey: ['my-teams'],
    queryFn: () => api.get<{ teams: MyTeam[] }>('/api/user/teams'),
    staleTime: 5 * 60_000,
  });
  return q.data?.teams ?? [];
}
